import { useUser } from "../../context/UserContext";
import { IPrivileges } from "../../types/IPrivileges";

export const usePrivileges = () => {
  const { privileges } = useUser();
  return privileges as IPrivileges;
};
